var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessages3Active({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/messages-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "messages-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.3334 5.20866V9.45864C18.3334 10.517 17.9834 11.4087 17.3584 12.0253C16.7417 12.6503 15.85 13.0003 14.7917 13.0003V14.5086C14.7917 15.0753 14.1583 15.417 13.6917 15.1003L12.8834 14.567C12.9584 14.3086 12.9917 14.0253 12.9917 13.7253V10.3337C12.9917 8.63368 11.8584 7.50033 10.1584 7.50033H4.50002C4.38335 7.50033 4.27502 7.50868 4.16669 7.51701V5.20866C4.16669 3.08366 5.58335 1.66699 7.70835 1.66699H14.7917C16.9167 1.66699 18.3334 3.08366 18.3334 5.20866Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.9917 10.3334V13.725C12.9917 14.025 12.9584 14.3083 12.8834 14.5667C12.575 15.7916 11.5584 16.5583 10.1584 16.5583H7.89169L5.37502 18.2333C5.00002 18.4917 4.50002 18.2167 4.50002 17.7667V16.5583C3.65002 16.5583 2.94169 16.275 2.45002 15.7833C1.95002 15.2833 1.66669 14.575 1.66669 13.725V10.3334C1.66669 8.75002 2.65002 7.65835 4.16669 7.51668C4.27502 7.50835 4.38335 7.5 4.50002 7.5H10.1584C11.8584 7.5 12.9917 8.63335 12.9917 10.3334Z",
    fill: "currentColor",
    stroke: "white",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages3Active);
export default __webpack_public_path__ + "static/media/messages-3-active.f4d427c7f08faaafd522af168b42f2c0.svg";
export { ForwardRef as ReactComponent };